import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { useTranslation } from "@coworker/locales";

interface DeleteImageButtonProps {
  deleteImage: (images: string[]) => Promise<void>;
  selectedImages: string[];
  disabled: boolean;
}

export const DeleteImageButton = ({
  deleteImage,
  selectedImages,
  disabled,
}: DeleteImageButtonProps) => {
  const deleteCount = selectedImages.length;
  const { t } = useTranslation();
  const handleDelete = async () => {
    await deleteImage(selectedImages);
  };

  return (
    <FixaButton
      disabled={disabled}
      ssrIcon={TrashCanIconPath}
      onClick={handleDelete}
      iconPosition="trailing"
      text={deleteCount > 1 ? t("deleteImagesString") : t("deleteImageString")}
      size="small"
      type="danger"
    />
  );
};
